module.exports = __webpack_public_path__ + "img/doball.d8436ea9.png";